import { c as _c } from "react/compiler-runtime";
import { ArticlePyramid } from "@/views/home/partials/articles/ArticlePyramid";
import type { Post } from "@/payload-types";
interface FeaturedNewsProps {
  articles: Post[];
  sidebar?: React.ReactNode;
}

/**
 * News + standings block. Mirrors the classic layout's `ArticlePyramid +
 * StandingsCompact` sidebar pattern — 1 hero + 2 secondary + 3 tertiary on
 * the left, standings on the right. Reuses the site's `ArticlePyramid` and
 * standings sidebar 1:1.
 */
export function FeaturedNews(t0) {
  const $ = _c(9);
  const {
    articles,
    sidebar
  } = t0;
  let t1;
  if ($[0] !== articles) {
    t1 = articles.slice(0, 6);
    $[0] = articles;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div className="lg:col-span-2 flex flex-col"><ArticlePyramid articles={t1} heroSizes="(max-width: 1024px) 100vw, 66vw" priority={true} /></div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== sidebar) {
    t3 = sidebar && <div>{sidebar}</div>;
    $[4] = sidebar;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">{t2}{t3}</div>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}